import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    cart: [],
    user: null
    // currentPaidSubscription: null
  },
  getters: {
    getCart: state => state.cart,
    getUser: state => state.user
  },
  mutations: {
    updateCart(state, cartObject) {
      state.cart = cartObject.cart;
    },
    addToCart(state, productObject) {
      if (state.cart.length == 0) {
        state.cart.push(productObject.product);
      } else {
        state.cart[0] = productObject.product;
      }
    },
    emptyCart(state) {
      state.cart = [];
    },
    updateUser(state, userObject) {
      state.user = userObject.user;
    },
    clearAuth(state) {
      state.user = null;
    }
  },
  actions: {
    addToCart({ commit }, product) {
      commit("addToCart", product);
    },
    emptyCart(context) {
      context.commit("emptyCart");
    },
    updateCart({ commit }, cart) {
      commit("updateCart", cart);
    },
    updateUser({ commit }, user) {
      commit("updateUser", user);
    },
    clearAuth(context) {
      context.commit("clearAuth");
    }
  },
  plugins: [createPersistedState()]
});
